import getCaps from '@anm/data/streaming/destinationsCaps';
import { SocialDestination } from 'types/stream';
import getDestinationExpireDate from '../getDestinationExpireDate';

const isDestinationDisconnected = (destination: SocialDestination) => {
  const expireDate = new Date(destination.expiresOn || Date.now()).getTime();
  const hoursToExpire = getDestinationExpireDate(destination.expiresOn)?.hoursToExpire;
  const canExpire = destination.network && !getCaps(destination.network, destination.kind)?.tokenDoesNotExpire;
  const isAlreadyExpired = expireDate < Date.now();
  const isExpiresSoon = hoursToExpire && Math.abs(hoursToExpire) && hoursToExpire <= 1;

  const isExpireError = !!(canExpire && (isAlreadyExpired || isExpiresSoon));

  return destination.error === 'SHOULD_RECONNECT' || isExpireError;
};

export default isDestinationDisconnected;
